import { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';

export enum AuthConstants {
  LOGIN_API = '/auth/insured-login',
  USER_TOKEN = 'digitalUserToken',
  USER_DATA_EMAIL = 'digitalUserDataEmail',
  USER_DATA_FIRSTNAME = 'digitalUserDataFirstName',
  USER_DATA_LASTNAME = 'digitalUserDataLastName',
}

export enum AuthMechanism {
  LOCAL = 'LOCAL', // For Mock Authentication using Contact Id
  ADB2C = 'ADB2C', // For ADB2C Authentication
  KEYCLOAK = 'KEYCLOAK', // For KEYCLOAK Authentication
}

// Configuration for creating an instance of KeyCloak
export const keyCloakConfig: KeycloakConfig = {
  url: process.env.GATSBY_KEYCLOAK_AUTH_URL || '',
  realm: process.env.GATSBY_KEYCLOAK_REALM || '',
  clientId: process.env.GATSBY_KEYCLOAK_CLIENT || '',
};

// Configuration for initializing KeyCloak
export const keyCloakInitOptions: KeycloakInitOptions = {
  onLoad: 'login-required',
};
